import { createAsyncThunk } from '@reduxjs/toolkit';
import httpService from './httpService';

export const getSystemPortalDashboard: any = createAsyncThunk<any>(
	'getSystemPortalDashboard',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get('/system-portal/dashboard');
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getTenantDashboard: any = createAsyncThunk<any>(
	'getTenantDashboard',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get('/system-portal/dashboard', {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getDashboardSummary: any = createAsyncThunk<any>(
	'getDashboardSummary',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get('/productService/order/dashboardSummary', {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

// Commented out: sales chart now uses getDashboardSummary "Sales Stats" (day-wise), client-side grouping for WEEK/MONTH
// export const getDashboardSalesData: any = createAsyncThunk<any>(
// 	'getDashboardSalesData',
// 	async (data: any, { rejectWithValue }) => {
// 		try {
// 			const response = await httpService.get('/system-portal/dashboardSalesState', {
// 				params: data
// 			});
// 			return response.data;
// 		} catch (error: any) {
// 			return rejectWithValue(error?.response?.data);
// 		}
// 	}
// );

// Commented out: Top categories are now uses getDashboardSummary "Top Categories"
// export const getDashboardTopCat: any = createAsyncThunk<any>(
// 	'getDashboardTopCat',
// 	async (data: any, { rejectWithValue }) => {
// 		try {
// 			const response = await httpService.get('/productService/category/dashboard/topCategory', {
// 				params: data
// 			});
// 			return response.data;
// 		} catch (error: any) {
// 			return rejectWithValue(error?.response?.data);
// 		}
// 	}
// );
